import React, { useContext, useEffect, useState } from 'react'
import Context from '../../context'
import history from '../../services/history'

import { DateListHelperInvert } from '../../helpers/DateListHelper'

import {
  createUnity,
  getAmenitiesList,
  getPartnerById,
  getUnityById
} from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'

import { ParseUnitiesImagesList } from '../../helpers/ParserHelper'

import AddressForm from '../../components/AddressForm'
import BankAccountForm from '../../components/BankAccountForm'
import CompanyForm from '../../components/CompanyForm'
import ContactForm from '../../components/ContactForm'
import ContractForm from '../../components/ContractForm'
import FormNavigation from '../../components/FormNavigation'
import ImagesDragDrop from '../../components/ImagesDragDrop'
import ProgressBar from '../../components/ProgressBar'
import ToastMessages from '../../components/ToastMessages'
import UnityDataForm from '../../components/UnityDataForm'
import { FORM_OBJECT, OBLIGATED_FIELDS } from '../../helpers/Variables'

export default function UnityForm() {
  const { editUnity, setUser, editPartner, setOpenToast } = useContext(Context)

  useEffect(() => {
    if (isAuthenticated) {
      setUser(getLoggedUser)
    } else {
      history.replace('/')
    }
  }, [])

  const [isLoading, setIsLoading] = useState(true)
  const [amenities, setAmenities] = useState([])
  const [tempAmenities, setTempAmenities] = useState([])
  const [imageList, setImageList] = useState([])
  const [newImageList, setNewImageList] = useState([])
  const [formObject, setFormObject] = useState(FORM_OBJECT)
  const [obligatedList, setObligatedList] = useState(OBLIGATED_FIELDS)
  const [partnerUnitImages, setPartnerUnitImagens] = useState([])
  const [bankInfo, setBankInfo] = useState({ label: '', value: '' })
  const [clubPercent, setClubPercent] = useState(null)

  useEffect(() => {
    const getAmenities = async () => {
      return getAmenitiesList()
    }

    getAmenities().then(r => {
      const newArr = [...r]
      const list = newArr.map(item => {
        return { ...item, selected: false }
      })
      setAmenities([...list])
    })
  }, [])

  useEffect(() => {
    if (amenities && tempAmenities) {
      if (amenities.length > 0 && tempAmenities.length > 0) {
        const list = [...tempAmenities]
        const newArr = amenities.map(item => {
          if (list.includes(item.id)) {
            return { ...item, selected: true }
          }
          return { ...item }
        })
        setAmenities(newArr)
      }
    }
  }, [tempAmenities])

  const [steps, setSteps] = useState({
    step: 1,
    maxStep: 5
  })

  const [latLong, setLatLong] = useState({ lat: '', long: '' })
  const [tags, setTags] = useState([])
  const [missInputs, setMissInputs] = useState(true)

  const getPartner = async () => {
    return getPartnerById(editPartner.id)
  }

  const getUnityToEdit = async () => {
    return getUnityById(editUnity.id)
  }

  useEffect(() => {
    setFormObject({ ...formObject, partnerUnitImagens: [...imageList] })
  }, [imageList])

  useEffect(() => {
    if (editPartner.id) {
      getPartner().then(partner => {
        const { discountAmount, hasCourtesy, hasDelivery, roles } = partner
        setFormObject({
          ...formObject,
          roles,
          hasCourtesy,
          hasDelivery,
          discountAmount
        })

        if (editUnity) {
          getUnityToEdit().then(r => {
            const {
              PartnerUnityOpeningHours,
              contactPhone,
              contactName,
              PartnerUnitImagens,
              PartnerUnitAmenities,
              PartnerUnitPayment
            } = r

            setTempAmenities(
              PartnerUnitAmenities?.map(item => {
                return item.amenitiesId
              })
            )

            PartnerUnitImagens && setNewImageList(ParseUnitiesImagesList(PartnerUnitImagens))

            const hasInAppPurchase = !!PartnerUnitPayment

            const {
              accountNumber,
              accountVerificationCode,
              branchCode,
              bankCode,
              branchVerificationCode,
              accountType,
              partnerUnitId,
              partnerPercent
            } = PartnerUnitPayment || ''

            if (bankCode) setBankInfo({ ...bankInfo, value: bankCode })
            if (partnerPercent) setClubPercent(100 - partnerPercent)

            setFormObject({
              ...r,
              partnerUnityOpeningHours: DateListHelperInvert(PartnerUnityOpeningHours),
              fullNameContact: contactName,
              phoneNumberContact: contactPhone,
              partnerUnitImagens: PartnerUnitImagens,
              partnerUnitAmenities: PartnerUnitAmenities,
              hasInAppPurchase,
              accountNumber,
              accountVerificationCode,
              branchCode,
              bankCode,
              branchVerificationCode,
              accountType,
              partnerUnitId,
              roles,
              hasCourtesy,
              hasDelivery,
              discountAmount
            })
            setIsLoading(false)
          })
        } else {
          setIsLoading(false)
        }
      })
    } else {
      history.replace('/partnerslist')
    }
  }, [editPartner, editUnity])

  useEffect(() => {
    const newArr = newImageList.filter(item => {
      return item.sended
    })
    setPartnerUnitImagens(newArr)
  }, [newImageList])

  const handleContinue = async () => {
    if (steps.step < steps.maxStep) {
      setSteps({ ...steps, step: steps.step + 1 })
    }

    if (steps.step === steps.maxStep) {
      setIsLoading(true)

      const unity = {
        ...formObject,
        latLong,
        partnerId: editPartner.id,
        partnerUnitAmenities: [...amenities]
      }

      if (editUnity) {
        unity.id = editUnity.id
      }

      const createdUnity = await createUnity(unity)

      if (createdUnity.id) {
        setIsLoading(false)
        setFormObject(FORM_OBJECT)
        const toastMessage = editUnity
          ? 'Unidade Atualizada com Sucesso'
          : 'Unidade Criada com Sucesso'
        history.replace('/unitieslist', {
          showToast: true,
          toastMessage
        })
      } else if (unity.hasInAppPurchase) {
        history.replace('/unitieslist')
        setOpenToast({
          open: true,
          message: createdUnity.message,
          type: 'error'
        })
      } else {
        setOpenToast({
          open: true,
          message: 'Ocorreu algum erro ao salvar',
          type: 'error'
        })
      }
      // if (missInputs) {
      //   setOpenToast({
      //     open: true,
      //     message:
      //       'Existem campos obrigatórios sem preencher, favor verificar todos os campos',
      //     type: 'error',
      //   });
      // }
    }
  }

  const checkValue = (key, value) => {
    if (obligatedList.filter(item => item.key === key).length > 0 && value.length === 0) {
      const newArr = obligatedList.map(item => {
        if (item.key === key) {
          setOpenToast({
            open: true,
            message: item.message,
            type: 'error'
          })
          return { ...item, showRed: true }
        }
        return { ...item }
      })
      setObligatedList(newArr)
      setMissInputs(true)
    } else {
      const newArr = obligatedList.map(item => {
        if (item.key === key) {
          setOpenToast({
            open: false,
            message: '',
            type: 'error'
          })
          return { ...item, showRed: false }
        }
        return { ...item }
      })
      setObligatedList(newArr)
      setMissInputs(false)
    }
  }

  const checkIsRed = key => {
    const obj = obligatedList.find(item => item.key === key)
    return obj.showRed || false
  }

  return (
    <div className="container-fluid h-100">
      <ToastMessages />
      {isLoading ? (
        <ProgressBar width="100%" height="30px" marginTop="30px" />
      ) : (
        <>
          <Context.Provider
            value={{
              latLong,
              setLatLong,
              tags,
              setTags,
              imageList,
              setImageList,
              partnerUnitImages,
              setPartnerUnitImagens,
              newImageList,
              setNewImageList,
              amenities,
              setAmenities,
              formObject,
              setFormObject,
              setOpenToast,
              bankInfo,
              setBankInfo,
              clubPercent,
              setClubPercent
            }}
          >
            <form
              className="clube-form form-row"
              onSubmit={e => {
                e.preventDefault()
              }}
            >
              {steps.step === 1 && (
                <div className="col-12">
                  <CompanyForm formType="unity" checkValue={checkValue} checkIsRed={checkIsRed} />
                  <AddressForm title="Endereço da Unidade" />
                  <ContactForm
                    hideBirth={editUnity !== null}
                    hideCourtesyText={editUnity !== null}
                  />
                </div>
              )}

              {steps.step === 2 && (
                <div className="col-12">
                  <ContractForm editUnity showAmenities />
                </div>
              )}

              {steps.step === 3 && (
                <div className="col-12">
                  <UnityDataForm />
                </div>
              )}

              {steps.step === 4 && (
                <div className="col-12">
                  <BankAccountForm />
                </div>
              )}

              {steps.step === steps.maxStep && (
                <div className="col-12">
                  <ImagesDragDrop />
                </div>
              )}

              <div className="col-12">
                <button
                  onClick={handleContinue}
                  type="button"
                  className="btn clube-button clube-blue"
                >
                  {steps.step !== steps.maxStep ? 'Continuar' : 'Concluir'}
                </button>
              </div>
            </form>
          </Context.Provider>

          <Context.Provider value={{ steps, setSteps }}>
            <FormNavigation />
          </Context.Provider>
        </>
      )}
    </div>
  )
}
